const PROCESSING = '1';
const PENDING = '2';
const APPROVED = '3';
const REJECTED = '4';
const FORWARDED = '5';
const RETURNED = '6';
const SIGNED = '7';

export default {
  PROCESSING,
  PENDING,
  APPROVED,
  REJECTED,
  FORWARDED,
  RETURNED,
  SIGNED
};
